/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */
import React from 'react';
/*
  Accepts an array and html div element that is being observed for resizes.
*/
export const useResizeObserver = (
  listContainerRef: React.RefObject<HTMLDivElement | null>,
  collections: unknown[],
  /**
   * Optional ResizeObserver implementation for dependency injection (testing, polyfills).
   * Defaults to window.ResizeObserver when not provided.
   */
  ResizeObserverImpl: typeof ResizeObserver = window.ResizeObserver,
): number => {
  const [listHeight, setListHeight] = React.useState(350); // default fallback
  React.useEffect(() => {
    const node = listContainerRef.current;
    if (!node) {
      return;
    }
    const resizeObserver = new ResizeObserverImpl((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          if (collections && collections.length > 1) {
            setListHeight(entry.contentRect.height - 150); // Subtract header height + accordion summary height
          } else {
            setListHeight(entry.contentRect.height - 115); // Subtract header height
          }
        }
      }
    });

    resizeObserver.observe(node);
  }, [listContainerRef, collections, ResizeObserverImpl]);

  return listHeight;
};
